// src/Models/ticketMandatoryFieldModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class TicketMandatoryFieldModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      mandatoryFieldID: data.mandatoryFieldID ?? data.mandatoryFieldId ?? data.mandatory_Field_ID ?? data.mandatory_field_id ?? data.id ?? data.Id ?? data.ID ?? 0,
      projectID: data.projectID ?? data.projectId ?? data.project_ID ?? data.project_id ?? data.ProjectID ?? data.ProjectId ?? '',
      statusID: data.statusID ?? data.statusId ?? data.status_ID ?? data.status_id ?? data.StatusID ?? data.StatusId ?? '',
      fieldName: data.fieldName ?? data.field_Name ?? data.field_name ?? data.FieldName ?? '',
      isMandatoryFlag: data.isMandatoryFlag !== undefined 
        ? Boolean(data.isMandatoryFlag === true || data.isMandatoryFlag === 'true' || data.isMandatoryFlag === 1)
        : (data.is_Mandatory_Flag !== undefined ? Boolean(data.is_Mandatory_Flag) : (data.IsMandatoryFlag !== undefined ? Boolean(data.IsMandatoryFlag) : false)),
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      mandatoryFieldId: Number(data.mandatoryFieldID ?? data.mandatoryFieldId ?? data.id ?? 0),
      projectId: Number(data.projectID ?? data.projectId ?? 0),
      statusId: Number(data.statusID ?? data.statusId ?? 0),
      fieldName: String(data.fieldName ?? data.field_Name ?? data.FieldName ?? '').trim(),
      isMandatoryFlag: data.isMandatoryFlag === true || data.isMandatoryFlag === 'true' || data.isMandatoryFlag === 1,
    };
  }
}

export default TicketMandatoryFieldModel;
